import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { RouteService } from '../../../../../core/services/route/route.service';
import { RouteConstants } from '../../../../../core/constants/routes';
import { ApplicationService } from '../../services/application/application.service';

export const DirectEntryPageApplicationStateRefreshResolver = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
): Observable<boolean> => {
    const routeService = inject(RouteService);
    const applicationService = inject(ApplicationService);

    const router = inject(Router);

    const url = routeService.getPreviousUrl();
    const applicationId = route.parent?.paramMap.get('id');

    if (!applicationId) {
        return navigateToHome(router);
    }

    /**
     * Checks to see if the requested URL is in the set steps for Direct Entry.
     */
    if (RouteConstants.Application.IsDirectEntryApplicationRoute(url)) {
        applicationService.getApplicationState(applicationId).subscribe();
    }

    return of(true);
};
